import { deleteNotificationsAction } from '@/actions/notifications/delete-notifications-action'
import { SelectedProductType } from '@/app/(routes)/my/notifications/contexts/notification-context'
import { queryFactory } from '@/query-factory'
import { queries } from '@/shared/lib/tanstack-query/query-keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useDeleteNotification = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationKey: ['notifications', 'delete'],
    mutationFn: async (selected: SelectedProductType[]) => {
      const notificationIds = selected.map(
        ({ notificationId }) => notificationId,
      )
      const productIds = selected.map(({ productId }) => productId)
      await deleteNotificationsAction({
        notificationIds,
      })
      return productIds
    },
    onSettled: (data) => {
      if (data) {
        data.forEach((id) => {
          queryClient.invalidateQueries({
            queryKey: [queries.products.notificationStatus(id).queryKey],
          })
        })
      }
      queryClient.invalidateQueries({
        // TODO: params 지정
        queryKey: queryFactory.notification.getNotifications({}).queryKey,
      })
    },
  })
}
